module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_4_3.5ab38348.png";